var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.settings = {
            titleText: 'Confirm Action',
            bodyText: '',
            confirmText: 'Confirm',
            confirmColor: 'primary',
            cancelText: 'Cancel',
            confirmEnabled: true,
            cancelEnabled: true,
            miscText: ''
        };
        if (data) {
            this.settings = __assign({}, this.settings, data);
        }
    }
    ConfirmDialogComponent.prototype.ngOnInit = function () {
    };
    return ConfirmDialogComponent;
}());
export { ConfirmDialogComponent };
